import React, { useState } from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { sessionService } from 'redux-react-session';
import ReactGA from 'react-ga4';
import Accessibility from './common/helper/Accessibility';


/**
 * 為了記錄GA
 * @param {any} param0
 */
const CirculationRoute = ({ children }) => {

    Accessibility.start();
    ReactGA.set({ page: window.location.pathname });
    ReactGA.send({ hitType: "pageview", page: window.location.pathname + window.location.search, title: document.title });
    return (<>{children}</>);
};

export default CirculationRoute;

